import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/lib/api";
import { Eyebrow, Reveal } from "@/components/site/Motion";

export const Categories = () => {
  const [active, setActive] = useState(0);
  return (
    <section className="mx-auto max-w-[1400px] px-5 pb-24 sm:px-8 lg:pb-32" data-testid="categories-section">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <Eyebrow>Para todo tipo de evento</Eyebrow>
          <h2 className="mt-5 font-display text-4xl font-bold tracking-tight sm:text-6xl">Onde tem gente, tem foto.</h2>
        </div>
        <Link to="/eventos" className="group inline-flex items-center gap-2 text-sm font-semibold text-flash" data-testid="categories-all-link">
          Ver todas as galerias <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
        </Link>
      </Reveal>
      <Reveal className="mt-12 flex flex-col gap-3 lg:h-[560px] lg:flex-row" delay={0.1}>
        {CATEGORIES.map((c, i) => (
          <Link key={c.id} to={`/eventos?category=${c.id}`} onMouseEnter={() => setActive(i)} data-testid={`category-card-${c.id}`}
            className={`group relative h-[300px] overflow-hidden rounded-[1.75rem] border border-white/10 transition-[flex-grow] duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] lg:h-full ${active === i ? "lg:flex-[3.2]" : "lg:flex-1"}`}>
            <img src={c.img} alt={c.label} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
              <span className="font-mono text-xs text-flash">0{i + 1}</span>
              <h3 className="mt-2 font-display text-3xl font-bold sm:text-4xl">{c.label}</h3>
              <p className={`mt-2 max-w-xs text-sm text-foreground/85 transition-opacity duration-500 ${active === i ? "lg:opacity-100" : "lg:opacity-0"}`}>{c.desc}</p>
            </div>
          </Link>
        ))}
      </Reveal>
    </section>
  );
};
